import { useEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";

// third-party
import ReactApexChart from "react-apexcharts";
import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";

// chart options
const barChartOptions = {
  chart: {
    type: "bar",
    // height: 365,
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "45%",
      borderRadius: 4,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    categories: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  grid: {
    show: false,
  },
};

// ==============================|| MONTHLY BAR CHART ||============================== //

const MonthlyBarChart = ({
  series,
  optionsObj,
  radioValue,
  height = 500,
  flag = false,
  type = "bar",
}) => {
  const theme = useTheme();

  const { primary, secondary } = theme.palette.text;
  const info = theme.palette.info.light;

  const [seriesData] = useState([
    {
      data: [80, 95, 70, 42, 65, 55, 78],
    },
  ]);

  const [options, setOptions] = useState(barChartOptions);

  const changeRadioHandler = (e) => {
    const { name, value } = e.target;
    radioValue(value);
    console.log(name);
    console.log(value);
  };
  useEffect(() => {
    setOptions((prevState) => ({
      ...prevState,
      colors: [info],
      xaxis: {
        labels: {
          style: {
            colors: [
              secondary,
              secondary,
              secondary,
              secondary,
              secondary,
              secondary,
              secondary,
            ],
          },
        },
      },
      tooltip: {
        theme: "light",
      },
    }));
  }, [primary, info, secondary]);
  return (
    <div id="chart">
      {flag && (
        <Grid
          item
          sm={12}
          xs={12}
          md={12}
          lg={12}
          container
          justifyContent="flex-end"
        >
          <RadioGroup
            row
            name={"offerFor"}
            id={"offerFor"}
            // value={offerFor}
            onChange={changeRadioHandler}
            size="small"
          >
            <FormControlLabel value={"0"} control={<Radio />} label={"5D"} />
            <FormControlLabel
              value={"1"}
              control={<Radio />}
              label={"Weekly"}
            />
            <FormControlLabel
              value={"2"}
              control={<Radio />}
              label={"Monthly"}
            />
            <FormControlLabel
              value={"3"}
              control={<Radio />}
              label={"Yearly"}
            />
          </RadioGroup>
        </Grid>
      )}

      <ReactApexChart
        options={optionsObj}
        series={series}
        type={type}
        height={height}
      />
    </div>
  );
};

export default MonthlyBarChart;
